const setupFileUpload = (dropArea, fileInput, files, folderName) => {
  //////////// FILE UPLOAD //////////////////
  // ************************ Drag and drop ***************** //

  fileInput.addEventListener('change', (e) => handleFiles(e.target.files));

  // Prevent default drag behaviors
  ;['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
    dropArea.addEventListener(eventName, preventDefaults, false);
    document.body.addEventListener(eventName, preventDefaults, false);
  })

  // Highlight drop area when item is dragged over it
  ;['dragenter', 'dragover'].forEach(eventName => {
    dropArea.addEventListener(eventName, highlight, false);
  })

  ;['dragleave', 'drop'].forEach(eventName => {
    dropArea.addEventListener(eventName, unhighlight, false);
  });

  // Handle dropped files
  dropArea.addEventListener('drop', handleDrop, false);

  function preventDefaults(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  // Handle box highlight - Not used
  function highlight(e) {
    dropArea.classList.add('highlight');
  }

  function unhighlight(e) {
    dropArea.classList.remove('active');
  }

  function handleDrop(e) {
    const dt = e.dataTransfer;
    const files = dt.files;

    handleFiles(files);
  }

  // Progress Bar
  let uploadProgress = [];

  function initializeProgress(numFiles, progressBar) {
    progressBar.value = 0;
    uploadProgress = [];

    for (let i = numFiles; i > 0; i--) {
      uploadProgress.push(0);
    }
  }

  // Handle file upload / drop
  function handleFiles(files) {

    files = [...files];
    const filesLength = files.length;
    for (let file of files) {

      const galleryItemWrapper = document.createElement('div');
      galleryItemWrapper.id = `${file.name}-galleryItemWrap`;
      galleryItemWrapper.className = 'galleryItemWrap';

      const nameAndProgressWrapper = document.createElement('span');
      nameAndProgressWrapper.id = `${file.name}-nameAndProgressWrap`;
      nameAndProgressWrapper.className = 'nameAndProgressWrap';

      const fileName = document.createElement('div');
      fileName.id = `${file.name}-fileName`;

      const progressText = document.createElement("div");
      progressText.id = `${file.name}-progressText`;

      const progressBar = document.createElement("progress");
      initializeProgress(filesLength, progressBar);
      progressBar.id = `${file.name}-progress-bar`;
      progressBar.max = 100;
      progressBar.value = 0;

      const fileImageWrapper = document.createElement("div");
      fileImageWrapper.id = `${file.name}-fileImageWrapper`;
      fileImageWrapper.className = "file-image-wrapper";
      fileImageWrapper.innerHTML = "<svg width=\"39\" height=\"39\" viewBox=\"0 0 39 39\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
        "<path opacity=\"0.65\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.14228 9.96027L14.8352 0.267362C14.9839 0.103183 15.1987 0 15.4375 0H31.6875C33.0314 0 34.125 1.0936 34.125 2.4375V36.5625C34.125 37.9064 33.0314 39 31.6875 39H7.3125C5.9686 39 4.875 37.9064 4.875 36.5625V10.5625C4.875 10.3238 4.97815 10.109 5.14228 9.96027ZM7.65036 9.75L14.625 2.77537V8.93747C14.625 9.38437 14.261 9.75 13.8125 9.75H7.65036ZM7.3125 37.375C6.864 37.375 6.49998 37.0094 6.49998 36.5625V11.375H13.8125C15.1564 11.375 16.25 10.2814 16.25 8.93747V1.62497H31.6875C32.136 1.62497 32.5 1.9906 32.5 2.4375V36.5625C32.5 37.0094 32.136 37.375 31.6875 37.375H7.3125Z\" fill=\"#393B42\"/>\n" +
        "<rect x=\"13\" y=\"19\" width=\"26\" height=\"15\" rx=\"1\" fill=\"#393B42\"/>\n" +
        "<path d=\"M20.9866 23.0886V28.0211C20.9866 28.6315 20.8019 29.1139 20.4324 29.4684C20.0694 29.8228 19.5897 30 18.9933 30C18.3969 30 17.914 29.8228 17.5445 29.4684C17.1815 29.1139 17 28.6315 17 28.0211H18.1182C18.1247 28.323 18.1992 28.5626 18.3418 28.7398C18.4909 28.917 18.7081 29.0056 18.9933 29.0056C19.2785 29.0056 19.4957 28.917 19.6448 28.7398C19.7939 28.556 19.8684 28.3165 19.8684 28.0211V23.0886H20.9866Z\" fill=\"white\"/>\n" +
        "<path d=\"M27.5155 25.1266C27.5155 25.4744 27.4345 25.8026 27.2725 26.1111C27.1104 26.4196 26.8511 26.6723 26.4946 26.8692C26.138 27.0595 25.681 27.1547 25.1236 27.1547H23.8984V29.9311H22.7899V23.0886H25.1236C25.6421 23.0886 26.0797 23.1805 26.4362 23.3643C26.7992 23.5415 27.0683 23.7843 27.2433 24.0928C27.4248 24.4013 27.5155 24.7459 27.5155 25.1266ZM25.1236 26.2391C25.5449 26.2391 25.8593 26.1439 26.0667 25.9536C26.2742 25.7567 26.3779 25.481 26.3779 25.1266C26.3779 24.3783 25.9598 24.0042 25.1236 24.0042H23.8984V26.2391H25.1236Z\" fill=\"white\"/>\n" +
        "<path d=\"M33.4637 25.0577C33.2887 24.7164 33.0456 24.4604 32.7344 24.2897C32.4233 24.1125 32.0635 24.0239 31.6551 24.0239C31.2078 24.0239 30.8092 24.1256 30.4591 24.3291C30.1091 24.5326 29.8336 24.8214 29.6326 25.1955C29.4381 25.5696 29.3409 26.0028 29.3409 26.4951C29.3409 26.9873 29.4381 27.4238 29.6326 27.8045C29.8336 28.1786 30.1091 28.4674 30.4591 28.6709C30.8092 28.8744 31.2078 28.9761 31.6551 28.9761C32.258 28.9761 32.7474 28.8054 33.1234 28.4641C33.4993 28.1228 33.7295 27.6601 33.8137 27.0759H31.2759V26.18H35V27.0563C34.9287 27.5879 34.7407 28.0769 34.436 28.5232C34.1378 28.9695 33.7457 29.3272 33.2595 29.5963C32.7798 29.8589 32.245 29.9902 31.6551 29.9902C31.0198 29.9902 30.4397 29.8425 29.9146 29.5471C29.3895 29.2452 28.9714 28.8284 28.6603 28.2968C28.3556 27.7651 28.2033 27.1646 28.2033 26.4951C28.2033 25.8256 28.3556 25.225 28.6603 24.6934C28.9714 24.1617 29.3895 23.7482 29.9146 23.4529C30.4461 23.151 31.0263 23 31.6551 23C32.3746 23 33.0132 23.1805 33.5706 23.5415C34.1346 23.8959 34.543 24.4013 34.7958 25.0577H33.4637Z\" fill=\"white\"/>\n" +
        "</svg>\n"

      document.getElementById("gallery").appendChild(galleryItemWrapper);
      document.getElementById(`${file.name}-galleryItemWrap`).appendChild(fileImageWrapper);
      document.getElementById(`${file.name}-galleryItemWrap`).appendChild(nameAndProgressWrapper);
      document.getElementById(`${file.name}-nameAndProgressWrap`).appendChild(fileName);
      document.getElementById(`${file.name}-nameAndProgressWrap`).appendChild(progressBar);
      document.getElementById(`${file.name}-nameAndProgressWrap`).appendChild(progressText);

      uploadImage(file);
      previewFile(file);
    }
  }

  // File Preview
  function previewFile(file) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = function () {

      const button = document.createElement('button');
      button.innerText = 'Remove';

      const fileName = document.getElementById(`${file.name}-fileName`);

      button.id = file.name + '-button';

      fileName.innerText = file.name;
    };
  }

  // TODO refactor with try / catch
  function uploadImage(file) {
    const ref = firebase.storage().ref();
    const name = new Date() + '-' + file.name;
    const metadata = {
      contentType: file.type
    };

    const task = ref.child(`${folderName}/${name}`).put(file, metadata);

    task
      .then(snapshot => snapshot.ref.getDownloadURL())
      .then(url => {
        const currentButton = document.getElementById(`${file.name}-buttonWrapper`);
        currentButton.addEventListener("click", () => deleteFromFirebase(url, file.name));

        files.push(url);
      })
      .catch(console.error);


    task.on("state_changed",
      function progress(snapshot) { //progress
        const progressBar = document.getElementById(`${file.name}-progress-bar`);
        const progressText = document.getElementById(`${file.name}-progressText`);
        progressBar.value = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

        progressText.className = 'progressText';
        progressText.innerText = progressBar.value.toFixed(0) + '%';

      },

      function error(error) {
        switch (error.code) {
          case 'storage/unauthorized':
            // User doesn't have permission to access the object
            break;
          case 'storage/canceled':
            // User canceled the upload
            break;

          // ...

          case 'storage/unknown':
            // Unknown error occurred, inspect error.serverResponse
            break;
        }
      },

      function complete() {
        const progressBar = document.getElementById(`${file.name}-progress-bar`);
        const progressText = document.getElementById(`${file.name}-progressText`);
        progressText.parentNode.removeChild(progressText);

        const completedDiv = document.createElement("p");
        completedDiv.id = `${file.name}-completedText`;
        completedDiv.className = "completedText";
        completedDiv.innerText = "Completed";

        const buttonWrapper = document.createElement("div");
        buttonWrapper.id = `${file.name}-buttonWrapper`;


        document.getElementById(`${file.name}-galleryItemWrap`).appendChild(buttonWrapper);
        buttonWrapper.innerHTML = "<svg class=\"icon-interaction__trash\"  width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" ><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.72076 1.75C7.61315 1.75 7.51762 1.81886 7.48359 1.92094L7.04057 3.25L12.9594 3.25L12.5164 1.92094C12.4824 1.81886 12.3868 1.75 12.2792 1.75L7.72076 1.75ZM14.5406 3.25L13.9394 1.4466C13.7012 0.732003 13.0325 0.25 12.2792 0.25L7.72076 0.25C6.96751 0.25 6.29876 0.732003 6.06056 1.4466L5.45943 3.25H3L1 3.25C0.585786 3.25 0.25 3.58579 0.25 4C0.25 4.41421 0.585786 4.75 1 4.75H2.29834L3.06497 16.2494C3.19629 18.2193 4.83242 19.75 6.80666 19.75H13.1933C15.1676 19.75 16.8037 18.2193 16.935 16.2494L17.7017 4.75H19C19.4142 4.75 19.75 4.41421 19.75 4C19.75 3.58579 19.4142 3.25 19 3.25L17 3.25H14.5406ZM16.1983 4.75H14L6 4.75L3.80166 4.75L4.56164 16.1497C4.64044 17.3316 5.62212 18.25 6.80666 18.25H13.1933C14.3779 18.25 15.3596 17.3316 15.4384 16.1497L16.1983 4.75ZM8 7.25C8.41421 7.25 8.75 7.58579 8.75 8L8.75 15C8.75 15.4142 8.41421 15.75 8 15.75C7.58579 15.75 7.25 15.4142 7.25 15L7.25 8C7.25 7.58579 7.58579 7.25 8 7.25ZM12.75 8C12.75 7.58579 12.4142 7.25 12 7.25C11.5858 7.25 11.25 7.58579 11.25 8L11.25 12C11.25 12.4142 11.5858 12.75 12 12.75C12.4142 12.75 12.75 12.4142 12.75 12L12.75 8Z\"  fill=\"#393B42\" ></path>  </svg>";
        document.getElementById(`${file.name}-nameAndProgressWrap`).appendChild(completedDiv);
        progressBar.parentNode.removeChild(progressBar);
      },
    );
  }

  // TODO remove Delete Button and Progress Bar
  const deleteFromFirebase = async (url, fileName) => {
    const storage = firebase.storage();
    const galleryItemWrap = document.getElementById(`${fileName}-galleryItemWrap`);

    if (galleryItemWrap) {
      galleryItemWrap.parentNode.removeChild(galleryItemWrap);
    }

    // Image Ref
    let pictureRef = storage.refFromURL(url);
    // Delete

    try {
      await pictureRef.delete();
    } catch (e) {
      console.log(e);
    }
  };
  //////////// FILE UPLOAD //////////////////
};
